export const modeTypes: {
  development: 'development';
  production: 'production';
  mock: 'mock';
} = {
  development: 'development',
  production: 'production',
  mock: 'mock',
};

export type ModeTypes = 'development' | 'production' | 'mock';
